import { render, staticRenderFns } from "./MemberExpel.vue?vue&type=template&id=5656d6d0&"
import script from "./MemberExpel.vue?vue&type=script&lang=ts&"
export * from "./MemberExpel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports